import { useAssetsStore } from '@/stores/assetsStore';

const STORAGE_KEY = 'compliance-assets-data';

export const persistence = {
  saveAll: () => {
    try {
      const data = useAssetsStore.getState().exportData();
      localStorage.setItem(STORAGE_KEY, data);
      return true;
    } catch (error) {
      console.error('Failed to save data:', error);
      return false;
    }
  },

  loadAll: () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        useAssetsStore.getState().importData(data);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Failed to load data:', error);
      return false;
    }
  },

  clear: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      return true;
    } catch (error) {
      console.error('Failed to clear data:', error);
      return false;
    }
  },

  exportToFile: () => {
    try {
      const data = useAssetsStore.getState().exportData();
      const blob = new Blob([data], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `compliance-assets-${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      return true;
    } catch (error) {
      console.error('Failed to export file:', error);
      return false;
    }
  },

  importFromFile: (file: File): Promise<boolean> => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = e.target?.result as string;
          useAssetsStore.getState().importData(data);
          resolve(true);
        } catch (error) {
          console.error('Failed to import file:', error);
          resolve(false);
        }
      };
      reader.onerror = () => resolve(false);
      reader.readAsText(file);
    });
  }
};